const MEDIA_PLAYING_CLASS = 'media-box--playing';

class MediaBox {
	constructor(element) {
		this._handleOnScreenChange = this._handleOnScreenChange.bind(this);
		this.playFullVideo = this.playFullVideo.bind(this);
		this.pauseVideo = this.pauseVideo.bind(this);
		this.resumeVideo = this.resumeVideo.bind(this);

		this._element = element;
		this._videoEl = this._element.querySelector('video');
		this._setup();
		this._listen();
	}

	_setup() {
		if (this.getType() === 'video' && this._isVideoPlayable()) {
			this._previewVideoUrl = this._videoEl.src;
			this._videoStatus = 'preview';
			this.resumeVideo();
		}
	}

	_listen() {
		if (this.getType() === 'video' && this._isVideoPlayable()) {
			this._videoEl.addEventListener('pause', this.pauseVideo);
			this._element.addEventListener('click', () => {
				if (this._videoStatus === 'preview') this.playFullVideo();
				else if (this._videoStatus === 'playing') this.pauseVideo();
				else if (this._videoStatus === 'paused') this.resumeVideo();
			});
			this._onScreenObserver = new IntersectionObserver(
				this._handleOnScreenChange,
				{
					threshold: 0,
				}
			);
			this._onScreenObserver.observe(this._element);
		}
	}

	_handleOnScreenChange([entry]) {
		if (!entry.isIntersecting) this.pauseVideo();
		else if (this._videoStatus === 'preview') this.resumeVideo();
	}

	_isVideoPlayable() {
		return this._element.dataset.mediaBoxControls === 'play';
	}

	_loadPreviewVideo() {
		if (!this._previewVideoUrl) return;
		if (this._previewVideoUrl !== this._videoEl.src)
			this._videoEl.setAttribute('src', this._previewVideoUrl);
		else {
			this._videoEl.currentTime = 0;
			this._videoEl.muted = true;
		}
		this._videoStatus = 'preview';
	}

	isPreview() {
		return this._videoStatus === 'preview';
	}

	getType() {
		return this._videoEl ? 'video' : 'image';
	}

	playFullVideo() {
		const doPlay = () => {
			this._videoEl.play();
			this._videoEl.muted = false;
		};
		this._videoEl.addEventListener('canplaythrough', doPlay, {
			once: true,
		});
		// this._videoEl.setAttribute('src', this._previewVideoUrl);
		this._videoEl.currentTime = 0;
		this._element.classList.add(MEDIA_PLAYING_CLASS);
		this._videoStatus = 'playing';
		this._element.dispatchEvent(new CustomEvent('playVideo'));
	}

	pauseVideo() {
		if (this._videoStatus === 'playing') {
			this._videoEl.pause();
			this._element.classList.remove(MEDIA_PLAYING_CLASS);
			this._videoStatus = 'paused';
			this._element.dispatchEvent(new CustomEvent('pauseVideo'));
		}
	}

	stopVideo() {
		this._loadPreviewVideo();
		if (this._videoStatus === 'playing') {
			this._element.classList.remove(MEDIA_PLAYING_CLASS);
			this._videoStatus = 'paused';
			this._element.dispatchEvent(new CustomEvent('pauseVideo'));
		}
	}

	resumeVideo() {
		this._videoEl.play();
		if (this._videoStatus === 'paused') {
			this._element.classList.add(MEDIA_PLAYING_CLASS);
			this._videoStatus = 'playing';
			this._element.dispatchEvent(new CustomEvent('playVideo'));
		}
	}
}

document
	.querySelectorAll('.wp-block-occasions-media-box')
	.forEach((el) => new MediaBox(el));
